export const FallbackNetwork = ({ labels = [], center = "F", className = "" }) => {
  const R = 38;
  const pts = labels.map((_, i) => {
    const a = (i / labels.length) * Math.PI * 2 - Math.PI / 2;
    return { x: 50 + R * Math.cos(a), y: 50 + R * Math.sin(a) };
  });
  return (
    <svg viewBox="0 0 100 100" className={className} data-testid="fallback-network" aria-hidden="true">
      {pts.map((p, i) => (
        <line key={`l${i}`} x1="50" y1="50" x2={p.x} y2={p.y} stroke="currentColor" strokeOpacity="0.25" strokeWidth="0.3" className="animate-dash" />
      ))}
      <circle cx="50" cy="50" r="9" fill="none" stroke="#8BC34A" strokeWidth="0.5" />
      <circle cx="50" cy="50" r="5.5" fill="#8BC34A" fillOpacity="0.2" />
      <text x="50" y="51.6" textAnchor="middle" fontSize="5" fontWeight="800" fill="#8BC34A" fontFamily="monospace">{center}</text>
      {pts.map((p, i) => (
        <g key={`n${i}`}>
          <circle cx={p.x} cy={p.y} r="2" fill="#8BC34A" className="animate-pulse-soft" style={{ animationDelay: `${i * 0.3}s` }} />
          <text x={p.x} y={p.y - 4} textAnchor="middle" fontSize="3.2" fill="currentColor" fillOpacity="0.75" fontFamily="monospace">
            {labels[i]}
          </text>
        </g>
      ))}
    </svg>
  );
};
